import { ColDef, GridReadyEvent } from 'ag-grid-community'
import dateRenderer from 'components/column-renderers/date'
import InfinityAgGrid from 'components/table/InfinityAgGrid'
import { UIModal } from 'features/UI'
import { useShowControl } from 'hooks/useShowControl'
import { SyntheticEvent } from 'react'
import { CaregiverPromoCode } from 'types'

const columnDefs: ColDef[] = [
  { headerName: 'Promo Code', field: 'code' },
  { headerName: 'Person of Concern', field: 'personOfConcern' },
  {
    headerName: 'Effective Date',
    cellRenderer: dateRenderer('effectiveDate'),
    colId: 'effectiveDate',
  },
]

/**
 * A Family Caregiver on several care teams holds one promo code per Person of Concern. The cell
 * shows the count; the popup lists each code with the person it belongs to.
 */
export function UserPromoCodesCell({ promoCodes }: { promoCodes: CaregiverPromoCode[] }) {
  const [isOpen, onOpen, onClose] = useShowControl()

  const handleOpen = (event: SyntheticEvent) => {
    event.preventDefault()
    onOpen()
  }

  const handleGridReady = (event: GridReadyEvent) => {
    event.api.sizeColumnsToFit()
  }

  return (
    <div>
      <a href="" onClick={handleOpen}>
        {promoCodes.length}
      </a>

      <UIModal isOpen={isOpen} onClose={onClose} width={860} title="Promo Codes">
        <div
          className="ag-theme-alpine"
          style={{ height: '400px', width: '812px', fontSize: '1rem' }}
        >
          <InfinityAgGrid
            rowData={promoCodes}
            columnDefs={columnDefs}
            rowModelType="clientSide"
            onGridReady={handleGridReady}
            floatingFiltersHeight={0}
          />
        </div>
      </UIModal>
    </div>
  )
}
